export const asyncScrollToElement = (
	id: string,
	scrollElement: HTMLElement | Window = window,
	offset: number = 0
) => {
	const el = document.getElementById(id);
	if (!el) return Promise.resolve();

	const isWindow = scrollElement === window;

	const container = isWindow
		? document.documentElement
		: (scrollElement as HTMLElement);
	const scrollTarget = isWindow ? window : (scrollElement as HTMLElement);

	const targetTop = Math.round(el.offsetTop) - offset;

	const maxScrollY = container.scrollHeight - container.clientHeight;
	const isTargetBottom = targetTop >= maxScrollY;

	const hasReachedTarget = () => {
		const currentScroll = isWindow
			? window.scrollY
			: (scrollElement as HTMLElement).scrollTop;
		const scrolledDistance = Math.ceil(currentScroll);
		const isAtTargetTop = Math.round(currentScroll) === targetTop;

		const isAtBottom =
			scrolledDistance + container.clientHeight >= container.scrollHeight;

		const reached = isAtTargetTop || (isTargetBottom && isAtBottom);

		return reached;
	};

	return new Promise(resolve => {
		const scrollListener = () => {
			if (hasReachedTarget()) {
				cleanup();
				return;
			}
		};

		const cleanup = () => {
			scrollTarget.removeEventListener('scroll', scrollListener);
			resolve(true);
		};

		scrollTarget.scrollTo({
			top: targetTop,
			behavior: 'smooth'
		});

		if (hasReachedTarget()) {
			window.requestAnimationFrame(() => {
				cleanup();
			});
			return;
		}

		scrollElement.addEventListener('scroll', scrollListener);
	});
};
